var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmspolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 233.412,
    viewBox: "0 0 248 233.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M332.518,213.5c-3.676-5.514-12.449-7.144-19.385-9.391s-11.021-6.708-9.183-17.748,11.4-28.977,11.222-32.244-33.055-3.059-36.121-2.012-3.669.812-6.527,4.487a50.865,50.865,0,0,0-4.286,6.285l3.542-7.445h.262a9.393,9.393,0,0,1,1.617-2.683,20.626,20.626,0,0,0,5-12.973c.134-7.023-4.863-6.345-5.809-4.186s-6.48,9.592-8.1,11.618-5,7.566-5,7.566l-3.75,13s-.818,3.877-5.514,18.573-2.65,21.471-2.65,21.471-1.227-.61-4.085,8.163-1.63,20,3.468,25.3,11.839,5.1,19.392,2.046A23.216,23.216,0,0,0,277.63,233.5s7.962-2.012,13.878-6.527,10.4-9.183,18.989-8.774,18.366,5.306,21.632,5.1S336.194,219.009,332.518,213.5Z",
    transform: "translate(-242.241 -134.11)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_message-bro",
    "data-name": "New message-bro",
    transform: "translate(-61.76 -71.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-32",
    transform: "translate(75.214 71.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M289.5,154.738a242.1,242.1,0,0,0-6.093-24.864c-7.421-23.661-22.191-47.6-47.558-55.651-18.728-5.936-38.939-1.84-54.764,10.26-24.82,18.973-42.884,44.864-70.041,61.295C88.368,159.5,76.5,181.676,84.124,213.016s33.087,49.6,60.954,47.381c23.161-1.866,47.376.13,67.4,11.359,17.894,10.033,49.511,1.3,75.665-26.106,15.239-15.976,13.761-36.288,8.794-55.268C293.863,178.627,291.872,166.637,289.5,154.738Z",
    transform: "translate(-81.818 -71.534)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M289.5,154.738a242.1,242.1,0,0,0-6.093-24.864c-7.421-23.661-22.191-47.6-47.558-55.651-18.728-5.936-38.939-1.84-54.764,10.26-24.82,18.973-42.884,44.864-70.041,61.295C88.368,159.5,76.5,181.676,84.124,213.016s33.087,49.6,60.954,47.381c23.161-1.866,47.376.13,67.4,11.359,17.894,10.033,49.511,1.3,75.665-26.106,15.239-15.976,13.761-36.288,8.794-55.268C293.863,178.627,291.872,166.637,289.5,154.738Z",
    transform: "translate(-81.818 -71.534)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-32",
    transform: "translate(61.76 297.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M309.76,421.616c0,2.093-55.525,3.8-124,3.8s-124-1.7-124-3.8,55.525-3.8,124-3.8S309.76,419.524,309.76,421.616Z",
    transform: "translate(-61.76 -417.82)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M309.76,421.616c0,2.093-55.525,3.8-124,3.8s-124-1.7-124-3.8,55.525-3.8,124-3.8S309.76,419.524,309.76,421.616Z",
    transform: "translate(-61.76 -417.82)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-32",
    transform: "translate(79.146 156.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M404.149,309.859c0,.034,1.724-1.777,1.818-1.9,1.093-1.462,2.348-4.937,1.16-6.607a2.421,2.421,0,0,0-3.589-.309,5.09,5.09,0,0,0-1.248,4.078C402.405,306.713,404.149,309.853,404.149,309.859Z",
    transform: "translate(-197.911 -238.732)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M400.676,293.956c-1.677-1.174-5.138.107-6.594,1.207-.127.1-1.925,1.818-1.892,1.831h.04c-.55.2-1.134.416-1.771.671-1.167.47-2.482,1.019-3.877,1.7a45.444,45.444,0,0,0-4.387,2.442,31.526,31.526,0,0,0-4.467,3.394.309.309,0,0,0-.047.047c.3-.516,1.08-2.012,1.127-2.12.671-1.7.959-5.366-.624-6.674a2.428,2.428,0,0,0-3.548.671,5.078,5.078,0,0,0-.121,4.259,15.951,15.951,0,0,0,3.012,4.025,42.405,42.405,0,0,0-3.864,4.219c-.671.865-1.375,1.757-2.012,2.683.242-.456.456-.872.476-.932.671-1.7.959-5.366-.624-6.674a2.421,2.421,0,0,0-3.542.671,5.063,5.063,0,0,0-.128,4.253,16.254,16.254,0,0,0,2.911,3.944l-.785,1.033c-1.207,1.684-2.4,3.354-3.629,4.977-.429.57-.872,1.12-1.341,1.664.215-.409.4-.751.416-.8.671-1.7.959-5.366-.624-6.708a2.421,2.421,0,0,0-3.548.671,5.054,5.054,0,0,0-.121,4.259,15.123,15.123,0,0,0,2.811,3.843c-.47.55-.939,1.093-1.422,1.6-.335.342-.63.671-.993,1.013l-1.026.966c-.671.59-1.342,1.207-2.046,1.771-.47.4-.919.758-1.341,1.127.429-.557,1.261-1.677,1.341-1.778a9.39,9.39,0,0,0,1.1-4.615,3.177,3.177,0,0,0,.228-.483,2.428,2.428,0,0,0-1.6-3.233c-2.012-.49-4.762,1.945-5.722,3.5-.054.094-.563,1.154-.865,1.831.114-.423.242-.838.356-1.274.241-.865.456-1.737.671-2.683.094-.456.195-.919.3-1.382s.161-.959.248-1.442c.168-1.127.288-2.274.389-3.434a14.949,14.949,0,0,0,4.816.671c1.355-.241,3.012-.845,3.7-2.113a2.415,2.415,0,0,0-1.093-3.434c-1.892-.792-5,1.2-6.185,2.589-.074.087-.812,1.181-1.207,1.791.054-.671.107-1.4.141-2.106.081-2.012.107-4.112.141-6.178,0-.631,0-1.261.04-1.892.268.074,3.468.979,4.984.745a5.064,5.064,0,0,0,3.7-2.113,2.428,2.428,0,0,0-1.1-3.434c-1.885-.785-5,1.207-6.185,2.6-.087.1-1.147,1.677-1.4,2.093.034-1.388.081-2.777.181-4.139a43.482,43.482,0,0,1,.738-5.48c.127,0,3.461.993,5.017.751a5.051,5.051,0,0,0,3.7-2.113,2.428,2.428,0,0,0-1.093-3.434c-1.892-.785-5,1.2-6.185,2.6-.08.087-.892,1.288-1.261,1.865l-.107-.04a30.97,30.97,0,0,1,1.724-5.292c.389-.946.812-1.824,1.248-2.683.6.242,3.354,1.342,4.789,1.261a5.048,5.048,0,0,0,3.911-1.7,2.428,2.428,0,0,0-.711-3.535c-1.791-.986-5.1.671-6.433,1.9-.074.067-.731.838-1.207,1.409.2-.376.4-.771.6-1.134.751-1.342,1.516-2.549,2.207-3.6.4-.59.765-1.12,1.12-1.617a16.232,16.232,0,0,0,4.809-1.087,4.993,4.993,0,0,0,2.683-3.307,2.415,2.415,0,0,0-2.26-2.8c-2.046-.054-4.226,2.918-4.83,4.642-.054.154-.6,2.576-.57,2.569H362q-.523.671-1.107,1.529c-.718,1.04-1.516,2.22-2.294,3.562a43.584,43.584,0,0,0-2.314,4.454,32.194,32.194,0,0,0-1.858,5.3.2.2,0,0,1,0,.067c0-.6-.2-2.267-.228-2.395-.376-1.784-2.167-5.017-4.2-5.219a2.421,2.421,0,0,0-2.6,2.5,5.058,5.058,0,0,0,2.247,3.615c1.227.932,4.481,1.664,4.742,1.717a43.587,43.587,0,0,0-.892,5.654c-.1,1.107-.174,2.22-.235,3.354-.047-.516-.094-.979-.107-1.04-.382-1.791-2.173-5.017-4.206-5.225a2.421,2.421,0,0,0-2.6,2.5,5.084,5.084,0,0,0,2.247,3.622,16.346,16.346,0,0,0,4.6,1.684c0,.429-.04.859-.054,1.288-.081,2.066-.148,4.132-.275,6.151-.047.711-.121,1.415-.188,2.113-.04-.456-.087-.845-.094-.9-.382-1.791-2.173-5.017-4.206-5.225a2.421,2.421,0,0,0-2.6,2.5,5.071,5.071,0,0,0,2.247,3.622,14.9,14.9,0,0,0,4.467,1.65c-.087.718-.181,1.435-.3,2.12-.094.47-.148.932-.268,1.4l-.322,1.341c-.241.865-.476,1.764-.731,2.6-.174.584-.349,1.14-.523,1.7.054-.711.127-2.1.121-2.22-.1-1.818-1.382-5.286-3.354-5.8a2.421,2.421,0,0,0-2.945,2.073,5.047,5.047,0,0,0,1.67,3.917,18.272,18.272,0,0,0,4.4,2.408c-.3.926-.584,1.818-.872,2.683-1,2.918-1.939,5.312-2.616,6.976a.415.415,0,0,1-.074.168l1.221.671c.04-.107.087-.215.127-.329.671-1.7,1.549-4.139,2.489-7.11.3-.939.6-1.945.905-2.985a26.038,26.038,0,0,0,3.086.2,17.743,17.743,0,0,0,2.3,4.266c-.751.61-1.489,1.2-2.193,1.744-2.442,1.885-4.548,3.354-6.037,4.373l-.174.121,1.342.738c1.449-1.04,3.354-2.482,5.614-4.279.765-.617,1.576-1.295,2.395-2.012.3.255,2.75,2.334,4.2,2.75a5.064,5.064,0,0,0,4.239-.369,2.422,2.422,0,0,0,.443-3.575c-1.382-1.509-5.037-1.006-6.708-.241-.094.047-1.1.671-1.731,1.046.335-.288.671-.564,1-.865.671-.583,1.342-1.194,2.053-1.851l1.006-.986c.342-.329.671-.711,1.006-1.066.765-.845,1.5-1.737,2.214-2.65a15.89,15.89,0,0,0,3.636,3.247,5.112,5.112,0,0,0,4.253.275,2.428,2.428,0,0,0,.979-3.468c-1.14-1.7-4.829-1.757-6.587-1.254-.114.034-1.342.537-2.012.825.423-.55.859-1.1,1.268-1.677,1.2-1.657,2.361-3.354,3.528-5.071l1.08-1.556c.181.208,2.354,2.73,3.75,3.354a5.046,5.046,0,0,0,4.246.275,2.415,2.415,0,0,0,.979-3.468c-1.14-1.7-4.829-1.757-6.587-1.248-.128.034-1.885.765-2.321.973.792-1.14,1.6-2.274,2.435-3.354a41.472,41.472,0,0,1,3.636-4.165c.087.1,2.341,2.737,3.763,3.394a5.064,5.064,0,0,0,4.253.282,2.421,2.421,0,0,0,.979-3.468c-1.14-1.7-4.83-1.757-6.587-1.254-.114.034-1.449.59-2.079.865l-.067-.1a31.386,31.386,0,0,1,4.353-3.455c.852-.577,1.69-1.08,2.522-1.543a16.352,16.352,0,0,0,3.3,3.689,4.974,4.974,0,0,0,4.192.745,2.421,2.421,0,0,0,1.341-3.354c-.946-1.818-4.608-2.274-6.406-1.965-.1,0-1.08.3-1.784.51l1.127-.617c1.375-.711,2.683-1.288,3.83-1.784.671-.275,1.261-.516,1.825-.731a16.119,16.119,0,0,0,4.608,1.744,5.025,5.025,0,0,0,4.065-1.274,2.421,2.421,0,0,0-.309-3.481Z",
    transform: "translate(-178.769 -229.067)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M357.544,284.444c.973,1.274,4.159,2.931,4.165,2.931s.456-2.428.463-2.589c.107-1.824-.765-5.406-2.683-6.144a2.421,2.421,0,0,0-3.166,1.724C355.947,281.754,356.746,283.364,357.544,284.444Z",
    transform: "translate(-181.459 -231.527)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(165.363 41.962)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M404.149,309.859c0,.034,1.724-1.777,1.818-1.9,1.093-1.462,2.348-4.937,1.16-6.607a2.421,2.421,0,0,0-3.589-.309,5.09,5.09,0,0,0-1.248,4.078C402.405,306.713,404.149,309.853,404.149,309.859Z",
    transform: "translate(-363.274 -280.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M400.676,293.956c-1.677-1.174-5.138.107-6.594,1.207-.127.1-1.925,1.818-1.892,1.831h.04c-.55.2-1.134.416-1.771.671-1.167.47-2.482,1.019-3.877,1.7a45.444,45.444,0,0,0-4.387,2.442,31.526,31.526,0,0,0-4.467,3.394.309.309,0,0,0-.047.047c.3-.516,1.08-2.012,1.127-2.12.671-1.7.959-5.366-.624-6.674a2.428,2.428,0,0,0-3.548.671,5.078,5.078,0,0,0-.121,4.259,15.951,15.951,0,0,0,3.012,4.025,42.405,42.405,0,0,0-3.864,4.219c-.671.865-1.375,1.757-2.012,2.683.242-.456.456-.872.476-.932.671-1.7.959-5.366-.624-6.674a2.421,2.421,0,0,0-3.542.671,5.063,5.063,0,0,0-.128,4.253,16.254,16.254,0,0,0,2.911,3.944l-.785,1.033c-1.207,1.684-2.4,3.354-3.629,4.977-.429.57-.872,1.12-1.341,1.664.215-.409.4-.751.416-.8.671-1.7.959-5.366-.624-6.708a2.421,2.421,0,0,0-3.548.671,5.054,5.054,0,0,0-.121,4.259,15.123,15.123,0,0,0,2.811,3.843c-.47.55-.939,1.093-1.422,1.6-.335.342-.63.671-.993,1.013l-1.026.966c-.671.59-1.342,1.207-2.046,1.771-.47.4-.919.758-1.341,1.127.429-.557,1.261-1.677,1.341-1.778a9.39,9.39,0,0,0,1.1-4.615,3.177,3.177,0,0,0,.228-.483,2.428,2.428,0,0,0-1.6-3.233c-2.012-.49-4.762,1.945-5.722,3.5-.054.094-.563,1.154-.865,1.831.114-.423.242-.838.356-1.274.241-.865.456-1.737.671-2.683.094-.456.195-.919.3-1.382s.161-.959.248-1.442c.168-1.127.288-2.274.389-3.434a14.949,14.949,0,0,0,4.816.671c1.355-.241,3.012-.845,3.7-2.113a2.415,2.415,0,0,0-1.093-3.434c-1.892-.792-5,1.2-6.185,2.589-.074.087-.812,1.181-1.207,1.791.054-.671.107-1.4.141-2.106.081-2.012.107-4.112.141-6.178,0-.631,0-1.261.04-1.892.268.074,3.468.979,4.984.745a5.064,5.064,0,0,0,3.7-2.113,2.428,2.428,0,0,0-1.1-3.434c-1.885-.785-5,1.207-6.185,2.6-.087.1-1.147,1.677-1.4,2.093.034-1.388.081-2.777.181-4.139a43.482,43.482,0,0,1,.738-5.48c.127,0,3.461.993,5.017.751a5.051,5.051,0,0,0,3.7-2.113,2.428,2.428,0,0,0-1.093-3.434c-1.892-.785-5,1.2-6.185,2.6-.08.087-.892,1.288-1.261,1.865l-.107-.04a30.97,30.97,0,0,1,1.724-5.292c.389-.946.812-1.824,1.248-2.683.6.242,3.354,1.342,4.789,1.261a5.048,5.048,0,0,0,3.911-1.7,2.428,2.428,0,0,0-.711-3.535c-1.791-.986-5.1.671-6.433,1.9-.074.067-.731.838-1.207,1.409.2-.376.4-.771.6-1.134.751-1.342,1.516-2.549,2.207-3.6.4-.59.765-1.12,1.12-1.617a16.232,16.232,0,0,0,4.809-1.087,4.993,4.993,0,0,0,2.683-3.307,2.415,2.415,0,0,0-2.26-2.8c-2.046-.054-4.226,2.918-4.83,4.642-.054.154-.6,2.576-.57,2.569H362q-.523.671-1.107,1.529c-.718,1.04-1.516,2.22-2.294,3.562a43.584,43.584,0,0,0-2.314,4.454,32.194,32.194,0,0,0-1.858,5.3.2.2,0,0,1,0,.067c0-.6-.2-2.267-.228-2.395-.376-1.784-2.167-5.017-4.2-5.219a2.421,2.421,0,0,0-2.6,2.5,5.058,5.058,0,0,0,2.247,3.615c1.227.932,4.481,1.664,4.742,1.717a43.587,43.587,0,0,0-.892,5.654c-.1,1.107-.174,2.22-.235,3.354-.047-.516-.094-.979-.107-1.04-.382-1.791-2.173-5.017-4.206-5.225a2.421,2.421,0,0,0-2.6,2.5,5.084,5.084,0,0,0,2.247,3.622,16.346,16.346,0,0,0,4.6,1.684c0,.429-.04.859-.054,1.288-.081,2.066-.148,4.132-.275,6.151-.047.711-.121,1.415-.188,2.113-.04-.456-.087-.845-.094-.9-.382-1.791-2.173-5.017-4.206-5.225a2.421,2.421,0,0,0-2.6,2.5,5.071,5.071,0,0,0,2.247,3.622,14.9,14.9,0,0,0,4.467,1.65c-.087.718-.181,1.435-.3,2.12-.094.47-.148.932-.268,1.4l-.322,1.341c-.241.865-.476,1.764-.731,2.6-.174.584-.349,1.14-.523,1.7.054-.711.127-2.1.121-2.22-.1-1.818-1.382-5.286-3.354-5.8a2.421,2.421,0,0,0-2.945,2.073,5.047,5.047,0,0,0,1.67,3.917,18.272,18.272,0,0,0,4.4,2.408c-.3.926-.584,1.818-.872,2.683-1,2.918-1.939,5.312-2.616,6.976a.415.415,0,0,1-.074.168l1.221.671c.04-.107.087-.215.127-.329.671-1.7,1.549-4.139,2.489-7.11.3-.939.6-1.945.905-2.985a26.038,26.038,0,0,0,3.086.2,17.743,17.743,0,0,0,2.3,4.266c-.751.61-1.489,1.2-2.193,1.744-2.442,1.885-4.548,3.354-6.037,4.373l-.174.121,1.342.738c1.449-1.04,3.354-2.482,5.614-4.279.765-.617,1.576-1.295,2.395-2.012.3.255,2.75,2.334,4.2,2.75a5.064,5.064,0,0,0,4.239-.369,2.422,2.422,0,0,0,.443-3.575c-1.382-1.509-5.037-1.006-6.708-.241-.094.047-1.1.671-1.731,1.046.335-.288.671-.564,1-.865.671-.583,1.342-1.194,2.053-1.851l1.006-.986c.342-.329.671-.711,1.006-1.066.765-.845,1.5-1.737,2.214-2.65a15.89,15.89,0,0,0,3.636,3.247,5.112,5.112,0,0,0,4.253.275,2.428,2.428,0,0,0,.979-3.468c-1.14-1.7-4.829-1.757-6.587-1.254-.114.034-1.342.537-2.012.825.423-.55.859-1.1,1.268-1.677,1.2-1.657,2.361-3.354,3.528-5.071l1.08-1.556c.181.208,2.354,2.73,3.75,3.354a5.046,5.046,0,0,0,4.246.275,2.415,2.415,0,0,0,.979-3.468c-1.14-1.7-4.829-1.757-6.587-1.248-.128.034-1.885.765-2.321.973.792-1.14,1.6-2.274,2.435-3.354a41.472,41.472,0,0,1,3.636-4.165c.087.1,2.341,2.737,3.763,3.394a5.064,5.064,0,0,0,4.253.282,2.421,2.421,0,0,0,.979-3.468c-1.14-1.7-4.83-1.757-6.587-1.254-.114.034-1.449.59-2.079.865l-.067-.1a31.386,31.386,0,0,1,4.353-3.455c.852-.577,1.69-1.08,2.522-1.543a16.352,16.352,0,0,0,3.3,3.689,4.974,4.974,0,0,0,4.192.745,2.421,2.421,0,0,0,1.341-3.354c-.946-1.818-4.608-2.274-6.406-1.965-.1,0-1.08.3-1.784.51l1.127-.617c1.375-.711,2.683-1.288,3.83-1.784.671-.275,1.261-.516,1.825-.731a16.119,16.119,0,0,0,4.608,1.744,5.025,5.025,0,0,0,4.065-1.274,2.421,2.421,0,0,0-.309-3.481Z",
    transform: "translate(-344.131 -271.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M357.544,284.444c.973,1.274,4.159,2.931,4.165,2.931s.456-2.428.463-2.589c.107-1.824-.765-5.406-2.683-6.144a2.421,2.421,0,0,0-3.166,1.724C355.947,281.754,356.746,283.364,357.544,284.444Z",
    transform: "translate(-348.114 -273.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M158.71,232.638c.04,0-.523-2.811-.584-2.978-.671-2.012-3.086-5.507-5.447-5.5A2.8,2.8,0,0,0,150,227.339c.174,1.657,1.664,3.072,3.012,3.884C154.578,232.182,158.71,232.638,158.71,232.638Z",
    transform: "translate(-109.448 -213.636)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M147.966,208.551c-2.227.8-3.354,4.917-3.26,7.023,0,.181.423,3.018.463,3h.047c-.181.671-.362,1.342-.55,2.113-.335,1.415-.671,3.018-.979,4.789a51.34,51.34,0,0,0-.631,5.762,36.576,36.576,0,0,0,.221,6.473.338.338,0,0,1,0,.081c-.288-.631-1.16-2.354-1.248-2.482-1.154-1.764-4.427-4.494-6.708-3.864a2.8,2.8,0,0,0-1.751,3.776c.6,1.549,2.415,2.522,3.931,2.951,1.71.49,5.52-.087,5.822-.134a49.182,49.182,0,0,0,1.4,6.453c.349,1.234.738,2.468,1.147,3.7-.268-.537-.516-1.013-.557-1.073-1.16-1.764-4.427-4.494-6.708-3.864a2.79,2.79,0,0,0-1.751,3.77c.6,1.556,2.415,2.529,3.931,2.958s4.789,0,5.655-.114c.161.47.315.946.476,1.415.778,2.254,1.57,4.508,2.274,6.708.248.785.463,1.57.671,2.348-.241-.476-.443-.872-.483-.926-1.154-1.764-4.427-4.494-6.708-3.864a2.79,2.79,0,0,0-1.751,3.77c.6,1.556,2.415,2.529,3.931,2.958s4.474.054,5.5-.094c.2.812.4,1.617.557,2.408.1.543.228,1.06.3,1.617s.148,1.08.228,1.61c.107,1.033.221,2.1.3,3.112.06.671.1,1.341.148,2.012-.235-.785-.738-2.314-.791-2.435a10.913,10.913,0,0,0-3.615-4.118,3.276,3.276,0,0,0-.309-.537,2.8,2.8,0,0,0-4.112-.671c-1.784,1.549-1.342,5.782-.517,7.727.047.114.718,1.294,1.147,2.012-.322-.4-.624-.785-.959-1.194-.671-.8-1.342-1.583-2.066-2.428l-1.107-1.2c-.362-.409-.792-.791-1.194-1.194-.939-.912-1.945-1.791-2.971-2.683.671-.577,3.166-2.683,3.877-4.072s1.207-3.4.47-4.9A2.79,2.79,0,0,0,135.772,256c-2.012,1.254-2.2,5.507-1.684,7.553.034.127.57,1.549.879,2.328-.624-.51-1.241-1.026-1.885-1.529-1.871-1.442-3.8-2.844-5.728-4.253-.59-.429-1.174-.872-1.757-1.3.255-.208,3.24-2.616,4.025-4.2.7-1.409,1.214-3.4.476-4.9a2.79,2.79,0,0,0-3.964-1.254c-2.012,1.254-2.207,5.507-1.684,7.553,0,.154.812,2.207,1.033,2.717-1.288-.959-2.556-1.925-3.776-2.931a50.02,50.02,0,0,1-4.7-4.347c.121-.094,3.246-2.6,4.025-4.219.7-1.409,1.214-3.4.476-4.9a2.79,2.79,0,0,0-3.964-1.254c-2.012,1.254-2.207,5.507-1.684,7.553,0,.134.624,1.7.919,2.435l-.114.067a35.718,35.718,0,0,1-3.837-5.151c-.631-.993-1.174-2.012-1.684-2.958.624-.409,3.488-2.294,4.38-3.676s1.576-3.246,1.006-4.809a2.8,2.8,0,0,0-3.8-1.69c-2.126,1.033-2.79,5.239-2.5,7.325,0,.114.3,1.254.523,2.079-.221-.443-.456-.9-.671-1.342-.778-1.61-1.388-3.126-1.925-4.481-.3-.771-.543-1.469-.771-2.133.409-.718,2.012-3.649,2.173-5.252s-.087-3.609-1.342-4.736a2.8,2.8,0,0,0-4.152.255c-1.409,1.892-.06,5.936,1.16,7.653.1.148,2.012,2.287,2.012,2.247v-.047c.208.671.436,1.342.671,2.066.5,1.342,1.087,2.9,1.831,4.534a49.045,49.045,0,0,0,2.65,5.151,37.146,37.146,0,0,0,3.756,5.286l.054.054c-.59-.362-2.267-1.342-2.408-1.382-1.939-.832-6.171-1.3-7.727.476a2.8,2.8,0,0,0,.624,4.119c1.342.959,3.408.771,4.9.3,1.7-.537,4.554-3.119,4.783-3.354a49.638,49.638,0,0,0,4.7,4.608c.973.838,1.979,1.657,3,2.455l-1.053-.59c-1.939-.832-6.171-1.3-7.727.483a2.8,2.8,0,0,0,.617,4.112c1.342.966,3.407.771,4.91.3s4.025-2.629,4.655-3.213l1.181.919c1.9,1.449,3.8,2.891,5.614,4.36.637.516,1.248,1.053,1.865,1.583-.463-.262-.852-.483-.919-.51-1.932-.832-6.171-1.3-7.72.476a2.8,2.8,0,0,0,.617,4.118c1.342.959,3.407.771,4.91.3s3.763-2.428,4.534-3.112c.617.563,1.228,1.127,1.8,1.7.382.4.771.758,1.134,1.181l1.08,1.221c.671.8,1.342,1.63,1.965,2.428.436.55.845,1.087,1.254,1.623-.63-.523-1.892-1.523-2.012-1.59-1.791-1.12-5.9-2.227-7.707-.671a2.79,2.79,0,0,0,0,4.159c1.2,1.16,3.253,1.281,4.809,1.04,1.71-.268,4.816-2.294,5.2-2.549.671.892,1.342,1.764,1.925,2.6,2.093,2.884,3.723,5.366,4.836,7.117l.114.181,1.442-.7-.228-.342c-1.167-1.744-2.864-4.219-5.037-7.083-.671-.912-1.429-1.865-2.207-2.837a31.569,31.569,0,0,0,2.24-2.777,19.6,19.6,0,0,0,5.561.671c.074,1.12.134,2.207.174,3.233.148,3.555.141,6.527.1,8.606v.241l1.583-.771c0-2.066-.074-4.85-.288-8.15-.067-1.134-.161-2.348-.275-3.589.443-.107,4.025-1.033,5.366-2.113,1.228-.986,2.522-2.582,2.482-4.246a2.8,2.8,0,0,0-3.079-2.8c-2.341.3-4.306,4.078-4.7,6.158,0,.121-.121,1.476-.174,2.328-.047-.5-.087-1-.141-1.523-.107-1.026-.241-2.059-.382-3.159l-.262-1.617c-.074-.537-.221-1.093-.335-1.65-.282-1.288-.631-2.569-1.013-3.864.9-.087,4.105-.47,5.48-1.254s2.884-2.167,3.092-3.823a2.79,2.79,0,0,0-2.616-3.233c-2.361-.06-4.876,3.354-5.567,5.366-.047.121-.382,1.61-.557,2.428-.235-.771-.463-1.543-.724-2.321-.765-2.234-1.6-4.467-2.435-6.708l-.745-2.053c.322-.033,4.145-.4,5.681-1.281,1.342-.785,2.884-2.167,3.092-3.817a2.8,2.8,0,0,0-2.616-3.24c-2.361-.054-4.876,3.354-5.567,5.366-.054.154-.537,2.287-.637,2.837-.543-1.509-1.073-3.018-1.529-4.528a48.461,48.461,0,0,1-1.5-6.2c.148,0,4.139-.376,5.715-1.281,1.342-.785,2.884-2.167,3.092-3.823a2.8,2.8,0,0,0-2.616-3.233c-2.361-.06-4.876,3.354-5.567,5.366-.047.134-.416,1.757-.577,2.535h-.134a36.283,36.283,0,0,1-.355-6.412c0-1.181.114-2.307.221-3.4.751,0,4.179,0,5.681-.671s3.112-1.831,3.5-3.454a2.79,2.79,0,0,0-2.247-3.5c-2.341-.322-5.219,2.824-6.124,4.7-.054.107-.436,1.214-.711,2.012.06-.5.114-1.006.174-1.476.241-1.771.57-3.354.872-4.8.181-.8.355-1.529.53-2.207.738-.376,3.7-1.925,4.7-3.186s1.912-3.059,1.509-4.7a2.8,2.8,0,0,0-3.32-1.845Z",
    transform: "translate(-92.877 -208.47)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M103.522,259.823c1.845-.074,5.534-1.965,5.541-1.965s-2.012-2.053-2.133-2.167c-1.65-1.342-5.608-2.884-7.573-1.583a2.79,2.79,0,0,0-.49,4.132C99.927,259.535,101.946,259.911,103.522,259.823Z",
    transform: "translate(-91.133 -223.334)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(7.035)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M158.71,232.638c.04,0-.523-2.811-.584-2.978-.671-2.012-3.086-5.507-5.447-5.5A2.8,2.8,0,0,0,150,227.339c.174,1.657,1.664,3.072,3.012,3.884C154.578,232.182,158.71,232.638,158.71,232.638Z",
    transform: "translate(-115.223 -213.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M147.966,208.551c-2.227.8-3.354,4.917-3.26,7.023,0,.181.423,3.018.463,3h.047c-.181.671-.362,1.342-.55,2.113-.335,1.415-.671,3.018-.979,4.789a51.34,51.34,0,0,0-.631,5.762,36.576,36.576,0,0,0,.221,6.473.338.338,0,0,1,0,.081c-.288-.631-1.16-2.354-1.248-2.482-1.154-1.764-4.427-4.494-6.708-3.864a2.8,2.8,0,0,0-1.751,3.776c.6,1.549,2.415,2.522,3.931,2.951,1.71.49,5.52-.087,5.822-.134a49.182,49.182,0,0,0,1.4,6.453c.349,1.234.738,2.468,1.147,3.7-.268-.537-.516-1.013-.557-1.073-1.16-1.764-4.427-4.494-6.708-3.864a2.79,2.79,0,0,0-1.751,3.77c.6,1.556,2.415,2.529,3.931,2.958s4.789,0,5.655-.114c.161.47.315.946.476,1.415.778,2.254,1.57,4.508,2.274,6.708.248.785.463,1.57.671,2.348-.241-.476-.443-.872-.483-.926-1.154-1.764-4.427-4.494-6.708-3.864a2.79,2.79,0,0,0-1.751,3.77c.6,1.556,2.415,2.529,3.931,2.958s4.474.054,5.5-.094c.2.812.4,1.617.557,2.408.1.543.228,1.06.3,1.617s.148,1.08.228,1.61c.107,1.033.221,2.1.3,3.112.06.671.1,1.341.148,2.012-.235-.785-.738-2.314-.791-2.435a10.913,10.913,0,0,0-3.615-4.118,3.276,3.276,0,0,0-.309-.537,2.8,2.8,0,0,0-4.112-.671c-1.784,1.549-1.342,5.782-.517,7.727.047.114.718,1.294,1.147,2.012-.322-.4-.624-.785-.959-1.194-.671-.8-1.342-1.583-2.066-2.428l-1.107-1.2c-.362-.409-.792-.791-1.194-1.194-.939-.912-1.945-1.791-2.971-2.683.671-.577,3.166-2.683,3.877-4.072s1.207-3.4.47-4.9A2.79,2.79,0,0,0,135.772,256c-2.012,1.254-2.2,5.507-1.684,7.553.034.127.57,1.549.879,2.328-.624-.51-1.241-1.026-1.885-1.529-1.871-1.442-3.8-2.844-5.728-4.253-.59-.429-1.174-.872-1.757-1.3.255-.208,3.24-2.616,4.025-4.2.7-1.409,1.214-3.4.476-4.9a2.79,2.79,0,0,0-3.964-1.254c-2.012,1.254-2.207,5.507-1.684,7.553,0,.154.812,2.207,1.033,2.717-1.288-.959-2.556-1.925-3.776-2.931a50.02,50.02,0,0,1-4.7-4.347c.121-.094,3.246-2.6,4.025-4.219.7-1.409,1.214-3.4.476-4.9a2.79,2.79,0,0,0-3.964-1.254c-2.012,1.254-2.207,5.507-1.684,7.553,0,.134.624,1.7.919,2.435l-.114.067a35.718,35.718,0,0,1-3.837-5.151c-.631-.993-1.174-2.012-1.684-2.958.624-.409,3.488-2.294,4.38-3.676s1.576-3.246,1.006-4.809a2.8,2.8,0,0,0-3.8-1.69c-2.126,1.033-2.79,5.239-2.5,7.325,0,.114.3,1.254.523,2.079-.221-.443-.456-.9-.671-1.342-.778-1.61-1.388-3.126-1.925-4.481-.3-.771-.543-1.469-.771-2.133.409-.718,2.012-3.649,2.173-5.252s-.087-3.609-1.342-4.736a2.8,2.8,0,0,0-4.152.255c-1.409,1.892-.06,5.936,1.16,7.653.1.148,2.012,2.287,2.012,2.247v-.047c.208.671.436,1.342.671,2.066.5,1.342,1.087,2.9,1.831,4.534a49.045,49.045,0,0,0,2.65,5.151,37.146,37.146,0,0,0,3.756,5.286l.054.054c-.59-.362-2.267-1.342-2.408-1.382-1.939-.832-6.171-1.3-7.727.476a2.8,2.8,0,0,0,.624,4.119c1.342.959,3.408.771,4.9.3,1.7-.537,4.554-3.119,4.783-3.354a49.638,49.638,0,0,0,4.7,4.608c.973.838,1.979,1.657,3,2.455l-1.053-.59c-1.939-.832-6.171-1.3-7.727.483a2.8,2.8,0,0,0,.617,4.112c1.342.966,3.407.771,4.91.3s4.025-2.629,4.655-3.213l1.181.919c1.9,1.449,3.8,2.891,5.614,4.36.637.516,1.248,1.053,1.865,1.583-.463-.262-.852-.483-.919-.51-1.932-.832-6.171-1.3-7.72.476a2.8,2.8,0,0,0,.617,4.118c1.342.959,3.407.771,4.91.3s3.763-2.428,4.534-3.112c.617.563,1.228,1.127,1.8,1.7.382.4.771.758,1.134,1.181l1.08,1.221c.671.8,1.342,1.63,1.965,2.428.436.55.845,1.087,1.254,1.623-.63-.523-1.892-1.523-2.012-1.59-1.791-1.12-5.9-2.227-7.707-.671a2.79,2.79,0,0,0,0,4.159c1.2,1.16,3.253,1.281,4.809,1.04,1.71-.268,4.816-2.294,5.2-2.549.671.892,1.342,1.764,1.925,2.6,2.093,2.884,3.723,5.366,4.836,7.117l.114.181,1.442-.7-.228-.342c-1.167-1.744-2.864-4.219-5.037-7.083-.671-.912-1.429-1.865-2.207-2.837a31.569,31.569,0,0,0,2.24-2.777,19.6,19.6,0,0,0,5.561.671c.074,1.12.134,2.207.174,3.233.148,3.555.141,6.527.1,8.606v.241l1.583-.771c0-2.066-.074-4.85-.288-8.15-.067-1.134-.161-2.348-.275-3.589.443-.107,4.025-1.033,5.366-2.113,1.228-.986,2.522-2.582,2.482-4.246a2.8,2.8,0,0,0-3.079-2.8c-2.341.3-4.306,4.078-4.7,6.158,0,.121-.121,1.476-.174,2.328-.047-.5-.087-1-.141-1.523-.107-1.026-.241-2.059-.382-3.159l-.262-1.617c-.074-.537-.221-1.093-.335-1.65-.282-1.288-.631-2.569-1.013-3.864.9-.087,4.105-.47,5.48-1.254s2.884-2.167,3.092-3.823a2.79,2.79,0,0,0-2.616-3.233c-2.361-.06-4.876,3.354-5.567,5.366-.047.121-.382,1.61-.557,2.428-.235-.771-.463-1.543-.724-2.321-.765-2.234-1.6-4.467-2.435-6.708l-.745-2.053c.322-.033,4.145-.4,5.681-1.281,1.342-.785,2.884-2.167,3.092-3.817a2.8,2.8,0,0,0-2.616-3.24c-2.361-.054-4.876,3.354-5.567,5.366-.054.154-.537,2.287-.637,2.837-.543-1.509-1.073-3.018-1.529-4.528a48.461,48.461,0,0,1-1.5-6.2c.148,0,4.139-.376,5.715-1.281,1.342-.785,2.884-2.167,3.092-3.823a2.8,2.8,0,0,0-2.616-3.233c-2.361-.06-4.876,3.354-5.567,5.366-.047.134-.416,1.757-.577,2.535h-.134a36.283,36.283,0,0,1-.355-6.412c0-1.181.114-2.307.221-3.4.751,0,4.179,0,5.681-.671s3.112-1.831,3.5-3.454a2.79,2.79,0,0,0-2.247-3.5c-2.341-.322-5.219,2.824-6.124,4.7-.054.107-.436,1.214-.711,2.012.06-.5.114-1.006.174-1.476.241-1.771.57-3.354.872-4.8.181-.8.355-1.529.53-2.207.738-.376,3.7-1.925,4.7-3.186s1.912-3.059,1.509-4.7a2.8,2.8,0,0,0-3.32-1.845Z",
    transform: "translate(-99.912 -208.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M103.522,259.823c1.845-.074,5.534-1.965,5.541-1.965s-2.012-2.053-2.133-2.167c-1.65-1.342-5.608-2.884-7.573-1.583a2.79,2.79,0,0,0-.49,4.132C99.927,259.535,101.946,259.911,103.522,259.823Z",
    transform: "translate(-98.168 -223.334)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M122.613,325.7s11.2-27,17.473-25.824-10.732,43.043-10.732,43.043,19.707-37.174,33.149-37.174-4.93,41.084-21.947,54.781c0,0,26.871-28.957,42.547-22.692s-31.352,35.6-31.352,35.6,27.32-8.606,24.188-1.952-11.644,7.821-11.644,7.821l30.9,1.57H87.68l24.188-2.348S86.781,366,93.5,360.918s21.5,5.869,21.5,5.869-25.529-28.172-20.606-38.743,26.878,19.177,26.878,19.177-17.916-37.958-14.334-44.592S122.613,325.7,122.613,325.7Z",
    transform: "translate(-87.68 -238.551)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M122.613,325.7s11.2-27,17.473-25.824-10.732,43.043-10.732,43.043,19.707-37.174,33.149-37.174-4.93,41.084-21.947,54.781c0,0,26.871-28.957,42.547-22.692s-31.352,35.6-31.352,35.6,27.32-8.606,24.188-1.952-11.644,7.821-11.644,7.821l30.9,1.57H87.68l24.188-2.348S86.781,366,93.5,360.918s21.5,5.869,21.5,5.869-25.529-28.172-20.606-38.743,26.878,19.177,26.878,19.177-17.916-37.958-14.334-44.592S122.613,325.7,122.613,325.7Z",
    transform: "translate(-87.68 -238.551)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M127.6,340.51c9.854,29.118,9.854,49.724,9.854,49.724s-11.644.443-23.738-8.512",
    transform: "translate(-96.253 -251.943)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M141.77,351.356a174.63,174.63,0,0,1,8.049-25.536",
    transform: "translate(-105.488 -247.106)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M161.646,338.51l-25.08,37.181s-17.024-14.334-22.846-22.4",
    transform: "translate(-96.253 -251.284)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M148.45,397.617s26.421-12.543,37.174-19.707",
    transform: "translate(-109.099 -264.256)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M319.57,325.7s-11.2-27-17.44-25.824,10.732,43.043,10.732,43.043-19.707-37.174-33.142-37.174,4.923,41.084,21.947,54.781c0,0-26.878-28.957-42.553-22.692s31.358,35.6,31.358,35.6-27.327-8.606-24.188-1.952,11.644,7.821,11.644,7.821L247,380.873H354.51l-24.188-2.348S355.4,366,348.688,360.918s-21.5,5.869-21.5,5.869,25.536-28.172,20.606-38.743-26.878,19.177-26.878,19.177,17.923-37.958,14.334-44.613S319.57,325.7,319.57,325.7Z",
    transform: "translate(-146.789 -238.551)",
    fill: "#d1e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M319.57,325.7s-11.2-27-17.44-25.824,10.732,43.043,10.732,43.043-19.707-37.174-33.142-37.174,4.923,41.084,21.947,54.781c0,0-26.878-28.957-42.553-22.692s31.358,35.6,31.358,35.6-27.327-8.606-24.188-1.952,11.644,7.821,11.644,7.821L247,380.873H354.51l-24.188-2.348S355.4,366,348.688,360.918s-21.5,5.869-21.5,5.869,25.536-28.172,20.606-38.743-26.878,19.177-26.878,19.177,17.923-37.958,14.334-44.613S319.57,325.7,319.57,325.7Z",
    transform: "translate(-146.789 -238.551)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M355.694,340.51c-9.854,29.118-9.854,49.724-9.854,49.724s11.644.443,23.738-8.512",
    transform: "translate(-179.331 -251.943)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M349.239,351.356a174.625,174.625,0,0,0-8.049-25.536",
    transform: "translate(-176.256 -247.106)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M309.78,338.51l25.087,37.181s17.017-14.334,22.839-22.4",
    transform: "translate(-167.459 -251.284)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M328.26,397.617s-26.428-12.543-37.18-19.707",
    transform: "translate(-159.369 -264.256)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-32",
    transform: "translate(129.095 105.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 112.621,
    height: 196.509,
    rx: 6.75,
    fill: "#7d868a",
    stroke: "#7f8d94",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M255.051,138.168H241.032a1.442,1.442,0,0,1-1.442-1.442h0a1.435,1.435,0,0,1,1.442-1.435h14.019a1.435,1.435,0,0,1,1.435,1.435h0a1.436,1.436,0,0,1-1.435,1.442Z",
    transform: "translate(-190.953 -126.04)",
    fill: "#c5d4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M276.078,305.906H177.69V139.83h23.322l2.623,2.092a5.192,5.192,0,0,0,3.26,1.136H248.04a5.241,5.241,0,0,0,3.354-1.227l2.368-2h22.3Z",
    transform: "translate(-170.573 -127.535)",
    fill: "#fff",
    stroke: "#7d868a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.939
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M219.176,156.4l-1.342-4.325H184.35V305.288H274.1V156.4Z",
    transform: "translate(-172.766 -131.565)",
    fill: "#c5d4dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 83.443,
    height: 141.893,
    transform: "translate(14.737 26.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M253.521,403.9a2.24,2.24,0,1,0-2.24,2.234,2.24,2.24,0,0,0,2.24-2.234Z",
    transform: "translate(-194.064 -220.193)",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-32",
    transform: "translate(148.468 110.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 27.474,
    cy: 39.092,
    rx: 27.474,
    ry: 39.092,
    transform: "translate(0 82.37)",
    fill: "#c5d4dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 27.474,
    cy: 39.092,
    rx: 27.474,
    ry: 39.092,
    transform: "translate(0 82.37)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M233.273,248.661s-1.717-2.871-3.293-3.012-20.344,11.638-23.215,17.769a31.689,31.689,0,0,0,2.012,30.272c7.412,11.517,19.03,11.135,25.053,10.558s10.061-2.536,16.165-7.432,11.7-12.107,12.516-17-2.173-7.62-4.078-8.3-12.926-.543-20.955-8.72S233.273,248.661,233.273,248.661Z",
    transform: "translate(-201.901 -170.832)",
    fill: "#636c70",
    stroke: "#5e676c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M245.019,244.58a23.824,23.824,0,0,0-7.881,5.158c-3.012,3.293-4.87,8.458-5.011,16.051s2.294,16.186,11.745,19.915,17.909.859,20.633-1.724,6.037-9.88,6.037-9.88-15.039,4.025-22.2-4.447S245.019,244.58,245.019,244.58Z",
    transform: "translate(-211.213 -170.481)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M332.518,213.5c-3.676-5.514-12.449-7.144-19.385-9.391s-11.021-6.708-9.183-17.748,11.4-28.977,11.222-32.244-33.055-3.059-36.121-2.012-3.669.812-6.527,4.487a50.865,50.865,0,0,0-4.286,6.285l3.542-7.445h.262a9.393,9.393,0,0,1,1.617-2.683,20.626,20.626,0,0,0,5-12.973c.134-7.023-4.863-6.345-5.809-4.186s-6.48,9.592-8.1,11.618-5,7.566-5,7.566l-3.75,13s-.818,3.877-5.514,18.573-2.65,21.471-2.65,21.471-1.227-.61-4.085,8.163-1.63,20,3.468,25.3,11.839,5.1,19.392,2.046A23.216,23.216,0,0,0,277.63,233.5s7.962-2.012,13.878-6.527,10.4-9.183,18.989-8.774,18.366,5.306,21.632,5.1S336.194,219.009,332.518,213.5Z",
    transform: "translate(-214.545 -134.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(27.697)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M279.636,223.815c-22.705,3.387-29.842,8.807-27.575,16.266a11.531,11.531,0,0,0,2.247,4.025,1.828,1.828,0,0,0,.04.456s.4.241,1.006.671a19.251,19.251,0,0,0,2.569,2.086c1.489,1.415,2.824,3.186,2.549,4.829-.584,3.5-8.72,9.619-12.832,9.914s-5.541-3.79-6.124.584,8.458,15.159,17.205,13.992,16.038-13.415,16.038-13.415-1.167-2.012,4.7-8.163c3.85-4.025,9.357-5.8,13.576-7.452a77.589,77.589,0,0,0,11.611-4.454c10.377-5.084,22.705-1.69,22.705-1.69S302.342,220.387,279.636,223.815Z",
    transform: "translate(-241.994 -163.52)",
    fill: "#c5d4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M279.636,223.815c-22.705,3.387-29.842,8.807-27.575,16.266a11.531,11.531,0,0,0,2.247,4.025,1.828,1.828,0,0,0,.04.456s.4.241,1.006.671a19.251,19.251,0,0,0,2.569,2.086c1.489,1.415,2.824,3.186,2.549,4.829-.584,3.5-8.72,9.619-12.832,9.914s-5.541-3.79-6.124.584,8.458,15.159,17.205,13.992,16.038-13.415,16.038-13.415-1.167-2.012,4.7-8.163c3.85-4.025,9.357-5.8,13.576-7.452a77.589,77.589,0,0,0,11.611-4.454c10.377-5.084,22.705-1.69,22.705-1.69S302.342,220.387,279.636,223.815Z",
    transform: "translate(-241.994 -163.52)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M332.518,213.5c-3.676-5.514-12.449-7.144-19.385-9.391s-11.021-6.708-9.183-17.748,11.4-28.977,11.222-32.244-33.055-3.059-36.121-2.012-3.669.812-6.527,4.487a50.865,50.865,0,0,0-4.286,6.285l3.542-7.445h.262a9.393,9.393,0,0,1,1.617-2.683,20.626,20.626,0,0,0,5-12.973c.134-7.023-4.863-6.345-5.809-4.186s-6.48,9.592-8.1,11.618-5,7.566-5,7.566l-3.75,13s-.818,3.877-5.514,18.573-2.65,21.471-2.65,21.471-1.227-.61-4.085,8.163-1.63,20,3.468,25.3,11.839,5.1,19.392,2.046A23.216,23.216,0,0,0,277.63,233.5s7.962-2.012,13.878-6.527,10.4-9.183,18.989-8.774,18.366,5.306,21.632,5.1S336.194,219.009,332.518,213.5Z",
    transform: "translate(-214.545 -134.11)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M371.446,264.445s.429-1.717-4.44-4.025-6.875-.718-6.875.429S370.695,264.445,371.446,264.445Z",
    transform: "translate(-253.358 -175.307)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M302.178,149.7l-12.288,9.458h16.481S306.371,147.539,302.178,149.7Z",
    transform: "translate(-230.232 -139.154)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M285.23,249.314a17.173,17.173,0,0,1,6.359-4.514",
    transform: "translate(-228.698 -170.553)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M281.9,256.233a8.237,8.237,0,0,1,.731-1.563",
    transform: "translate(-227.602 -173.803)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M273.7,275.081a18.014,18.014,0,0,1-1.838-1.871",
    transform: "translate(-224.296 -179.907)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M289.633,281.18a17.99,17.99,0,0,1-10.933-2.24",
    transform: "translate(-226.548 -181.793)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M325.506,162.72H263.581c-8.552,0-15.481,6.62-15.481,14.757v29.178a14.968,14.968,0,0,0,12.228,14.455l-3.267,9.666,15.119-9.31h53.326c8.546,0,15.481-6.62,15.481-14.757V177.53C340.987,169.34,334.052,162.72,325.506,162.72Z",
    transform: "translate(-216.473 -143.529)",
    fill: "#d1e0e8",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 69.612,
    transform: "translate(41.708 38.837)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.064
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 69.612,
    transform: "translate(41.708 46.008)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.064
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 69.612,
    transform: "translate(41.708 53.171)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.064
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 69.612,
    transform: "translate(41.708 60.335)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.064
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 8.633,
    cy: 8.244,
    rx: 8.633,
    ry: 8.244,
    transform: "translate(115.318 28.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M383.034,191.554a3.563,3.563,0,0,1-.369-1.831v-6.708l-1.516.845a1.1,1.1,0,0,1-.537.148,1,1,0,0,1-.751-.329,1.08,1.08,0,0,1-.3-.765.926.926,0,0,1,.161-.543,2.273,2.273,0,0,1,.55-.476l2.938-1.5a2.321,2.321,0,0,1,1.113-.423c1,0,1.5.751,1.5,2.254v7.734c0,1.469-.523,2.2-1.576,2.2A1.288,1.288,0,0,1,383.034,191.554Z",
    transform: "translate(-259.755 -149.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M336.1,153.072a10.185,10.185,0,0,0,5.138,7.969c4.863,2.569,11.074,2.012,11.208-1.214s-3.649-6.62-6.211-10.947-8.244-1.885-10.672,1.087",
    transform: "translate(-245.268 -138.201)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M348.816,161.482c-.409,2.16,1.08,3.354,2.428,4.025a5.005,5.005,0,0,0,5.541-1.617c.067-1.583-.8-3.193-2.012-4.93C353.082,159.175,349.131,159.792,348.816,161.482Z",
    transform: "translate(-249.61 -142.292)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M320.993,153.072a10.169,10.169,0,0,0,5.131,7.969c4.863,2.569,11.081,2.012,11.215-1.214s-3.649-6.62-6.218-10.947-8.237-1.885-10.672,1.087",
    transform: "translate(-240.294 -138.201)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M333.716,161.482c-.409,2.16,1.08,3.354,2.428,4.025a5.005,5.005,0,0,0,5.54-1.617c.06-1.583-.8-3.193-2.012-4.93C337.982,159.175,334.031,159.792,333.716,161.482Z",
    transform: "translate(-244.639 -142.292)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M306.943,153.072a10.169,10.169,0,0,0,5.131,7.969c4.863,2.569,11.074,2.012,11.209-1.214s-3.642-6.62-6.211-10.947-8.244-1.885-10.672,1.087",
    transform: "translate(-235.668 -138.201)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M319.657,161.482c-.4,2.16,1.08,3.354,2.435,4.025a4.99,4.99,0,0,0,5.534-1.617c.067-1.583-.8-3.193-2.012-4.93C323.923,159.175,319.972,159.792,319.657,161.482Z",
    transform: "translate(-240.01 -142.292)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M250.58,244s.376,8.3,4.957,13.891",
    transform: "translate(-217.29 -170.29)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M228.231,294.169a2.564,2.564,0,1,1-2.515-3.059A2.827,2.827,0,0,1,228.231,294.169Z",
    transform: "translate(-208.275 -185.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M218.9,299.845a2.565,2.565,0,1,1-2.515-3.065A2.827,2.827,0,0,1,218.9,299.845Z",
    transform: "translate(-205.204 -187.667)",
    fill: "none",
    stroke: "#4a5459",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmspolicy);
export default __webpack_public_path__ + "static/media/smspolicy.2fb44b4122a1acd787c1cf6498d716a3.svg";
export { ForwardRef as ReactComponent };